<template>
  <div class="sms-biz-message-send">
    <el-tabs tab-position="top">
      <el-tab-pane label="学生消息"
                   lazy>
        <SmsBizStudentMessageSend v-on="$listeners"></SmsBizStudentMessageSend>
      </el-tab-pane>
      <el-tab-pane label="教师消息"
                   lazy>
        <SmsBizTeacherMessageSend v-on="$listeners"></SmsBizTeacherMessageSend>
      </el-tab-pane>
      <el-tab-pane label="班主任消息"
                   lazy>
        <SmsBizClassTeacherMessageSend v-on="$listeners"></SmsBizClassTeacherMessageSend>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SmsBizStudentMessageSend from './student'
import SmsBizTeacherMessageSend from './teacher'
import SmsBizClassTeacherMessageSend from './class-teacher'
export default {
  name: 'SmsBizMessageSend',
  components: {
    SmsBizStudentMessageSend,
    SmsBizTeacherMessageSend,
    SmsBizClassTeacherMessageSend
  }
}
</script>

<style lang="scss">
  .sms-biz-message-send {
    height: 420px;
    .el-tabs {
      &.el-tabs--top {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          margin-bottom: 0;
          padding: 0 15px;
          box-sizing: border-box;
          & > .el-tabs__nav-wrap {
            & > .el-tabs__nav-scroll {
              & > .el-tabs__nav {
                & > .el-tabs__item {
                  min-width: 92px;
                  height: 36px;
                  font-size: 13px;
                  text-align: center;
                  line-height: 36px;
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          position: absolute;
          left: 0;
          top: 36px;
          right: 0;
          bottom: 0;
          & > .el-tab-pane {
            height: 100%;
          }
        }
      }
    }
  }
</style>
